import {
  defaultPlantCapacityOptions,
  normalizePlantCapacityOptions,
  PLANT_CAPACITY_NAME_TO_NUMBER,
  PLANT_CAPACITY_NUMBER_TO_NAME,
  parsePlantCapacityForApi,
  resolvePlantCapacityOptions,
  unwrapCustomerRequestFormEnums,
} from "../SLN/shared/customerRequest/plantCapacityFormConstants";

export {
  initialRegistrationConditions,
  OWNERSHIP_REGISTRATION_CONDITION,
} from "../SLN/shared/customerRequest/initialRegistrationConditionsConstants";

export {
  defaultPlantCapacityOptions,
  normalizePlantCapacityOptions,
  PLANT_CAPACITY_NAME_TO_NUMBER,
  PLANT_CAPACITY_NUMBER_TO_NAME,
  parsePlantCapacityForApi,
  resolvePlantCapacityOptions,
  unwrapCustomerRequestFormEnums,
};

export const powerPlantTypeOptions = [
  { name: "متصل به شبکه", value: "1" },
  { name: "منفصل از شبکه", value: "2" },
  { name: "هیبریدی", value: "3" },
  { name: "هیبریدی بدون باطری", value: "4" },
];

export const locationUsageTypeOptions = [
  { name: "مسکونی", value: "1" },
  { name: "تجاری", value: "2" },
  { name: "اداری", value: "3" },
  { name: "صنعتی", value: "4" },
  { name: "کشاورزی", value: "5" },
  { name: "باغ و ویلا", value: "6" },
  { name: "مسجد / مذهبی", value: "7" },
  { name: "آموزشی", value: "8" },
  { name: "سایر", value: "9" },
];

export const ownershipStatusOptions = [
  { name: "مالک هستم", value: "1" },
  { name: "دارای مجوز استفاده", value: "3" },
  { name: "نیاز به بررسی", value: "4" },
];

export const platformAcquaintanceSourceOptions = [
  { name: "مهرسان", value: "1" },
  { name: "شبکه های اجتماعی", value: "2" },
  { name: "دوستان", value: "3" },
  { name: "سرچ گوگل", value: "4" },
  { name: "سایر", value: "5" },
];

export const applicantGoalOptions = [
  { label: "فروش برق به شبکه", value: 1 },
  { label: "کاهش هزینه برق", value: 2 },
  { label: "برق اضطراری", value: 4 },
  { label: "استقلال از شبکه", value: 8 },
  { label: "سرمایه‌گذاری", value: 16 },
  { label: "نیاز به مشاوره", value: 32 },
];

export const plantCapacityFormValue = (raw) => {
  if (raw == null || raw === "") return "";
  const key = String(raw).trim().toUpperCase();
  if (PLANT_CAPACITY_NAME_TO_NUMBER[key]) return key;
  const num = Number(raw);
  if (!Number.isNaN(num) && PLANT_CAPACITY_NUMBER_TO_NAME[num]) {
    return PLANT_CAPACITY_NUMBER_TO_NAME[num];
  }
  return String(raw);
};

export const formatApplicantGoalsLabel = (flags) => {
  const value = Number(flags) || 0;
  if (!value) return null;
  const labels = applicantGoalOptions
    .filter((goal) => (value & goal.value) === goal.value)
    .map((goal) => goal.label);
  return labels.length ? labels.join("، ") : null;
};

export const defaultAssistedRequestForm = {
  initialConditionsAccepted: false,
  plantKind: 1,
  companyId: 0,
  powerPlantType: "",
  locationUsageType: "",
  plantCapacity: "",
  installableAreaSquareMeter: "",
  electricBoillNumber: "",
  installationType: "Villa",
  unitCount: "",
  needsLoan: false,
  loanGuaranteeChequeIntent: "",
  guarantorFirstName: "",
  guarantorLastName: "",
  guarantorNationalCode: "",
  guarantorMobile: "",
  ownershipStatus: "",
  platformAcquaintanceSource: "",
  applicantGoalFlags: 0,
  provinceId: "",
  cityId: "",
  address: "",
  postalCode: "",
  xPoint: "",
  yPoint: "",
  locationInput: "",
  electricBoillUrl: "",
  plantInstallImage1Url: "",
  plantInstallImage2Url: "",
  nationalCardUrl: "",
  nationalCardBackUrl: "",
  boardConsentDocumentUrl: "",
  authorizedRepresentativeLetterUrl: "",
  agreementDocumentUrl: "",
  homeOwnerShipDocUrl: "",
  note: "",
};
